/**
 * ============================================================================
 * MIGRATED FILE — DO NOT EDIT
 * ============================================================================
 *
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/ratingsAndReview/queries/ratingsQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 *
 * @migrated-to academy-content-ui
 * ============================================================================
 */

import { registerQuery, useQuery } from 'academy-common-lib/utils/DataFetchingClient';
import { getReviewGroupValuesRpc, getStatsRpc, searchReviewsRpc } from 'academy-service-client/ecosystem-service-v1/operations';
import { rpcClient } from '../../../client';
const GET_RATINGS_TAGS = registerQuery({
  fieldName: 'ratingsTags',
  args: [],
  fetcher() {
    return rpcClient.call(getReviewGroupValuesRpc, {});
  }
});
const GET_RATINGS_STATS = registerQuery({
  fieldName: 'ratingsStats',
  args: ['entityId', 'reviewType', 'offeringId', 'profileId'],
  fetcher(queryParams) {
    return rpcClient.call(getStatsRpc, {
      data: queryParams
    });
  }
});
const POST_REVIEWS_SEARCH = registerQuery({
  fieldName: 'reviewsSearch',
  args: ['entityId', 'limit', 'offset', 'reviewTypes', 'reviewerPortalId', 'reviewerUserId', 'sortFields'],
  fetcher(params) {
    return rpcClient.call(searchReviewsRpc, {
      data: params
    });
  }
});

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/ratingsAndReview/queries/ratingsQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useGetReviewTags = () => {
  const {
    data,
    loading,
    error
  } = useQuery(GET_RATINGS_TAGS);
  return {
    ratingsTags: data,
    loading,
    error
  };
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/ratingsAndReview/queries/ratingsQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useGetReviewStats = options => {
  const {
    data,
    loading,
    error,
    refetch
  } = useQuery(GET_RATINGS_STATS, Object.assign({}, options));
  return {
    ratingsStats: data,
    loading,
    error,
    refetchRatings: refetch
  };
};

/**
 * @migrated-to academy-content-ui
 * @deprecated
 * This file has been migrated to academy-content-ui.
 * Canonical source: academy-content-ui/static/js/features/ratingsAndReview/queries/ratingsQueries.ts
 *
 * This .migrated copy is retained only for LearningCenterUI consumers that
 * have not yet moved to academy-content-ui. All changes should be made in
 * academy-content-ui first, then synced here if still needed.
 *
 * This copy will be deleted when LearningCenterUI is shut down.
 */
export const useSearchReviews = (data, options) => {
  const {
    data: searchReview,
    loading,
    error,
    refetch: refetchSearchReview
  } = useQuery(POST_REVIEWS_SEARCH, Object.assign({
    variables: data,
    skip: !data.reviewerUserId || !data.reviewerPortalId || !data.entityId
  }, options));
  return {
    searchReview,
    loading,
    error,
    refetchSearchReview
  };
};